export const EL_ID_TOP_PANEL = "topPanel";
